import { useState } from "react";
import { EstudianteActivoT, VoidEstudianteActivo } from "../../interfaces/SAAC/EstudianteActivo";
import { useFormik } from "formik";
import { EstudianteActivoValidate } from "../ValidationForm/validationForm";
import AcademicoService from "../../services/AcademicoService";
import { Alert, Box, Button, Grid, TextField, Typography } from "@mui/material";
import { MdOutlineCleaningServices, MdPersonSearch } from "react-icons/md";
import { EstudianteTabla } from "./EstudianteTabla";
import AlertService from "../../services/AlertService";

interface Props {
    token: any,
    ocultarBoton: boolean,
    tipo: string,
    estudiante: EstudianteActivoT,
    onResponse?: (dataRespuesta: any) => void // Función para pasar la respuesta al padre
    onClean?: (dataRespuesta: any) => void // Función para pasar la respuesta al padre
}

const academicoService = new AcademicoService();
const alertaService = new AlertService();

export const EstudianteActivo : React.FC<Props> = ({token, ocultarBoton, tipo, estudiante,onResponse, onClean}) => {
    //let [estudiante, setEstudiante] = useState<EstudianteActivoT>(VoidEstudianteActivo());
    const formik = useFormik({
        initialValues: {
            codestudiante: ''
        },
        validationSchema: EstudianteActivoValidate,
        onSubmit: (values) => {
            consultar(values.codestudiante);
        },
    });

    async function consultar(codestudiante: string) {
        alertaService.showLoading("Consultando datos...");

        const resp = await academicoService.GetCarreraActivaByMatricula(token, codestudiante, tipo);
        if (resp.status.isSuccessfully) {
            //console.log(resp.data);
            //setEstudiante(resp.data);
            
            alertaService.hideLoading();
            if(resp.data==null){
                alertaService.alertaAdvertencia("Matrícula no válida","La matrícula ingresa no es válida o el estudiante está inactivo.");

            }else{
                if (onResponse) {
                    onResponse(resp.data);
                    
                } else {
                    console.error('La función onResponse no está definida.');
                }
            }

            
        } else {
            console.error(resp.status.messages)
        }
    }

    function limpiar() {
        if(onClean){
            onClean(formik.setFieldValue('codestudiante', ''));
        }
        
    }

    return(
        <>
        {/* Formulario */}
            <Box
                sx={{
                    padding: "20px",
                    border: "1px solid #E0E0E0",
                    borderRadius: "10px",
                }}
            >
                <Typography
                    variant="subtitle1"
                    align="center"
                    gutterBottom
                    sx={{ fontWeight: "bold", fontSize: "14px" }}
                >
                    Consulta de estudiante
                </Typography>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} justifyContent="center">
                        {/* Campo de Matrícula */}
                        <Grid item xs={12} sm={8}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                id="codestudiante"
                                label="Matrícula"
                                value={formik.values.codestudiante}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.codestudiante && Boolean(formik.errors.codestudiante)}
                                sx={{
                                    backgroundColor: "#F5F5F5",
                                    "& .MuiInputBase-input": {
                                        fontSize: "14px", // Ajusta el tamaño del texto dentro del campo
                                    },
                                    "& .MuiInputLabel-root": {
                                        fontSize: "14px", // Ajusta el tamaño del texto de la etiqueta
                                    },
                                }}
                            />
                            {formik.touched.codestudiante && formik.errors.codestudiante && (
                            <Alert severity="error">{formik.errors.codestudiante}</Alert>
                            )}
                        </Grid>

                        {/* Botones */}
                        <Grid item xs={12} sm={4} sx={{ textAlign: "center" }}>
                            {
                                ocultarBoton ? 
                                <></>
                                :
                                <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                //onClick={handleConsultar}
                                
                                sx={{
                                    marginRight: 1, backgroundColor: "#243165",
                                    color: "#FFFFFF !important",
                                    "&:hover": { backgroundColor: "#1e284c" },
                                    boxShadow: 3,
                                }}
                                endIcon={<MdPersonSearch />}
                            >
                                Consultar
                            </Button>
                                
                            }
                            
                            <Button
                                variant="contained"
                                color="error"
                                //onClick={handleLimpiar}
                                onClick={limpiar}
                                endIcon={<MdOutlineCleaningServices />} 
                                sx={{
                                    marginRight: 1,
                                    color: "#FFFFFF !important",
                                    boxShadow: 3,
                                }}
                            >
                                Limpiar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                {estudiante.matricula !== '' ?
                    <EstudianteTabla estudiante={estudiante} />
                    : <></>

                }
            </Box>
        </>


    )


}



